<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    쌤즈 오픈 채팅 신고관리
                </div>
                <div class="list-content">
                    <declaration-list-component :declarationType="'openChat'"></declaration-list-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>
import DeclarationListComponent from "@/components/declaration/DeclarationListComponent";
    export default {
        name: "DeclarationSsamsOpenChat",
        mixins: [],
        components: {DeclarationListComponent},
        provide() {
            return {}
        },
        props: {},
        data() {
            return {
            }
        },
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {},
        methods: {

        },
        watch: {

        },
    }
</script>

<style lang="scss">
</style>